export default "__VITE_ASSET__CAvQ41bc__"